import { useState, useEffect, useContext } from 'react'
import { ref, onChildChanged, onValue, DataSnapshot } from 'firebase/database'

//contexts
import AuthContext from 'context/AuthContext'
import LoaderContext from 'context/LoaderContext'
//configs
import { db } from 'config/firebaseConfig'
//constants
import { IDENTITY_VERIFICATION_STATUS } from 'constants/index'
//services
import { getUserById } from 'services/userService'
//utils
import { handleError, isUserOutOfAttempts } from 'utils/utils'

const useRealtimeIdentityVerificationStatus = (userId?: string) => {
  const { updateUserData } = useContext(AuthContext)
  const { showLoader, hideLoader } = useContext(LoaderContext)

  const [verificationResult, setVerificationResult] = useState()
  const [outOfAttempts, setOutOfAttempts] = useState(false)

  useEffect(() => {
    if (!userId) {
      return
    }
    const notificationRef = ref(db, `identity_verification/${userId}`)

    const notificationHandler = async (snapshot: DataSnapshot) => {
      setVerificationResult(snapshot.val().state)
      showLoader()
      if (snapshot.val().state === IDENTITY_VERIFICATION_STATUS.FINISHED) {
        try {
          const data = await getUserById(userId)
          updateUserData(data.data)
          setOutOfAttempts(isUserOutOfAttempts(data.data))
        } catch (error) {
          handleError(error)
        }
      }
      hideLoader()
    }
    onValue(notificationRef, notificationHandler)
    onChildChanged(notificationRef, notificationHandler)
  }, [userId])

  return { verificationResult, outOfAttempts }
}

export default useRealtimeIdentityVerificationStatus
